import { Grid, MenuItem } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  vinculoReferenciaClienteFollowUpActions,
  vinculoReferenciaClienteFollowUpSelectors,
} from '../../../../../../features/vinculo-referencia-cliente-follow-up/vinculoReferenciaClienteFollowUpSlice';
import QCXFinalBondManagerOld from '../../../../../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManagerOld';
import DesviosAutoComplete from './DesviosAutoComplete';
import QCXFinalTextFieldAlt from '../../../../../../shared-components/final-text-field/QCXFinalTextFieldAlt';
import { setErrorFeedback } from '../../../../../../features/feedback/feedbackSlice';
import PrestadorAutocomplete from './PrestadorAutocomplete';

function DesviosBondManager({ isConsult }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const desviosListProps = useMemo(
    () => ({
      name: 'desvios',
      columns: [
        {
          field: 'description',
          headerName: t('com.muralis.qcx.listaFollowUp.desvioD'),
          flex: 140,
          valueGetter: ({ row }) => row?.description || '',
        },
        {
          field: 'prestador',
          headerName: 'Prestador',
          flex: 140,
          valueGetter: ({ row }) => row?.prestador || '',
        },
      ],
    }),
    []
  );

  const desviosFormProps = {
    rootName: 'ignorableFields.desvios.form',
    fields: [
      { name: 'desvio', label: t('com.muralis.qcx.listaFollowUp.desvio'), required: true },
      { name: 'prestador', label: 'Prestador', required: true },
    ],
  };

  const handleAdd = useCallback((current, list, onSuccess) => {
    const idRepetido = list.some(d => d.id === current.desvio.id);

    if (idRepetido) {
      dispatch(
        setErrorFeedback({
          message: 'Desvio já adicionado!',
        })
      );
      return;
    }


    const novoDesvio = {
      ...current.desvio,
      id: current.desvio.id,
      prestador: current.prestador,
    };
    onSuccess([...list, novoDesvio]);
  }, []);

  const referenciaClienteReducerConfig = useMemo(
    () => ({
      selectors: {
        selectStatus: vinculoReferenciaClienteFollowUpSelectors.selectStatus,
        selectMode: vinculoReferenciaClienteFollowUpSelectors.selectMode,
        selectModel: vinculoReferenciaClienteFollowUpSelectors.selectModel,
      },
      actions: {
        loading: vinculoReferenciaClienteFollowUpActions.loading,
        resetStatus: vinculoReferenciaClienteFollowUpActions.resetStatus,
        changeToUpdateMode: vinculoReferenciaClienteFollowUpActions.changeToUpdateMode,
        changeToCreateMode: vinculoReferenciaClienteFollowUpActions.changeToCreateMode,
        resetMode: vinculoReferenciaClienteFollowUpActions.resetMode,
        setModel: vinculoReferenciaClienteFollowUpActions.setModel,
        resetModel: vinculoReferenciaClienteFollowUpActions.resetModel,
      },
    }),
    []
  );

  return (
    <QCXFinalBondManagerOld
      isParentConsult={isConsult}
      listProps={desviosListProps}
      formProps={desviosFormProps}
      reducerConfig={referenciaClienteReducerConfig}
      handleAdd={handleAdd}
      disableConsult
      disabled={isConsult}
    >
      <Grid item xs={4} style={{ paddingBottom: '1rem' }}>
        <DesviosAutoComplete
          disabled={isConsult}
          name="ignorableFields.desvios.form.desvio"
        />
      </Grid>

      <Grid item xs={4} style={{ paddingBottom: '1rem' }}>
        <PrestadorAutocomplete
          disabled={isConsult}
          name="ignorableFields.desvios.form.prestador"
        />
      </Grid>
    </QCXFinalBondManagerOld>
  );
}

export default DesviosBondManager;
